import { useCallback, useMemo } from 'react'

import { Select } from 'govwell-ui'
import { SelectBaseProps, SelectOption } from 'govwell-ui/components/Select/types'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string, TValue> = SelectBaseProps<TValue> & {
  field: TanstackField<SelectOption<TValue> | null | undefined, TKey>
}

const SelectField = <TKey extends string, TValue>(props: Props<TKey, TValue>) => {
  const { field, ...selectBaseProps } = props
  const { options } = selectBaseProps

  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = errorMessage.length > 0

  const selectedOption = useMemo(() => {
    const value = field.state.value
    if (value === undefined || value === null) {
      return undefined
    }
    return options.find((option) => option.value === value.value)
  }, [field.state.value, options])

  const onSelectedOptionChange = useCallback(
    (option: SelectOption<TValue> | undefined) => {
      field.setValue(option)
    },
    [field]
  )

  return (
    <Select
      {...selectBaseProps}
      errorMessage={errorMessage}
      isInvalid={isInvalid}
      onBlur={field.handleBlur}
      onSelectedOptionChange={onSelectedOptionChange}
      selectedOption={selectedOption}
    />
  )
}

export default SelectField
